import { useState } from "react";
import { useLocalStorage } from "./useLocalStorage";
import { callAPI } from "./CallAPI";
import { useNavigate } from "react-router-dom"; // Si vous utilisez React Router pour la navigation
import { toast, ToastContainer } from 'react-toastify';

const useAuth = () => {
    const [user, setUser] = useLocalStorage("user", null);
    const navigate = useNavigate();

    const login = async (user_login, password) => {

        // on peut déjà gérer des erreurs ici
        if (!user_login || !password) {
            // Afficher un message d'erreur indiquant que les champs sont requis
            toast.error('Veuillez remplir tous les champs de connexion');
            return;
        }

        try {
            const resp = await callAPI('/login', { user_login: user_login, password: password });

            if (resp.success == 1) {
                sessionStorage.clear();
                setUser(resp.datas);
                // navigate('/dashboard');
                 // Vérifier le rôle de l'utilisateur et rediriger en conséquence
            if (resp.datas.role === "super_admin") {
                navigate('/admin-meosis');
            } else {
                navigate('/dashboard');
            }
            }
        } catch (error) {
            console.error('Erreur lors de la connexion:', error);
        }
    };

    const logout = (notification = true, msg = 'Déconnexion réussie') => {
        setUser(null);
        if (notification) {
            toast.info(msg);            
        }
        
        navigate("/", { replace: true });
    };

    return { user, login, logout };
};

export default useAuth;